module.exports = __webpack_public_path__ + "img/collection_img02.df463708.jpg";